module.exports = __webpack_public_path__ + "media/images/emblems/Loveresse-coat_of_arms-abd906cad3b3720eca5e4b3730623562.svg";